// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../public/assets/img/star-invert.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/******* Common CSS Start *******/
:root {
  --text-black: #2a2a2a;
  --bg-gray-color: #f8f8f8;
  --theme-blue-color: #35488a;
  --text-gray: #757575;
  --theme-dark-blue: #424a66;
  --theme-red-color: #f11616;
  --theme-gray-bg: #f2f4f7;
}

body {
  background-color: var(--bg-gray-color);
  color: var(--text-black) !important;
  margin: 0;
  font-family: "Manrope";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  position: relative;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New",
    monospace;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: "Manrope";
}

a,
.btn-link {
  font-family: "Manrope";
  color: var(--theme-blue-color);
}

.fs-12 {
  font-size: 12px;
}

.fs-14 {
  font-size: 14px;
}

.fs-16,
.btn.fs-16 {
  font-size: 16px;
}

.fs-18 {
  font-size: 18px;
}

.f400 {
  font-family: "Manrope";
}

.f500 {
  font-family: "Manrope";
}

.f600 {
  font-family: "Manrope";
}

.f700 {
  font-family: "Manrope-Bold";
}

input {
  color: var(--text-black);
  font-family: "Manrope";
}

input::placeholder {
  color: var(--text-gray);
  font-size: 14px;
}

header {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.16);
  -webkit-backdrop-filter: saturate(180%) blur(20px);
  backdrop-filter: saturate(180%) blur(20px);
  background-color: rgba(255, 255, 255, 0.62);
  position: sticky;
  top: 0;
  z-index: 9;
}

header .logo {
  width: 139px;
}

.MainSection {
  max-height: calc(100vh - 72px);
  margin-bottom: 50px;
  position: relative;
  display: inline-block;
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: scroll;
}

.erro {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  background-color: #fafafa;
  box-shadow: 0 9px 23px rgb(0 0 0 / 20%);
  font-size: 22px;
  color: #d44b4b;
  width: fit-content;
  padding: 29px 50px;
  margin-right: auto;
  margin-left: auto;
  margin-top: 15vh;
  margin-bottom: 5vh;
  text-transform: capitalize;
}

.erro img {
  margin-bottom: 20px;
}

.MainPage {
  max-width: 900px;
  margin-bottom: 70px;
}

.text-blue {
  color: var(--theme-blue-color);
}

.text-policy-blue {
  color: #444d91;
  font-size: 16px;
  font-weight: 700;
}

.btn-policy-blue {
  background-color: #444d91 !important;
  color: #ffffff;
  border-radius: 5px;
}

.btn-dash-sec {
  background: #e7e7e7 0% 0% no-repeat padding-box;
  border: 1px solid #cccccc;
  border-radius: 5px;
}

.w-50px {
  width: 50px;
}

.h-50px {
  height: 50px;
}

p {
  color: var(--text-black);
}

.error {
  padding-left: 18px;
  font-size: 12px;
  color: var(--theme-red-color);
  position: relative;
  z-index: 0;
  margin-top: 5px;
}

.error::before {
  content: "\\e80a";
  position: absolute;
  top: -3px;
  left: 0;
  font-family: "fontello";
  font-size: 15px;
}

/******* Common CSS End *******/
/******* Form Section CSS Start *******/
.FormSection {
  border-radius: 15px;
  box-shadow: 0px 0px 30.8px 0px #0000001A;

  /* box-shadow: 0px 7px 24px rgba(0, 0, 0, 0.07); */
  min-height: 400px;
}

.warningBox {
  border-radius: 15px;
  background-color: #FFF2E3;
  padding: 10px;
  margin-top: 30px;
}

.warningBox p {
  padding-top: 10px;
  text-align: center;
  color: #FFA439;
}

.btnAt {
  display: flex;
  justify-content: space-between;
  width: 87%;
  box-sizing: border-box;
  position: relative;
  border-radius: 6px;
  background-color: #082594;
  height: 40px;
}

.btnAt1 #formInp {
  width: 150%;
  margin-top: 1px;
  margin-left: 1px;
}

.btnAt1 {
  display: flex;
  justify-content: space-between;
  width: 87%;
  box-sizing: border-box;
  position: relative;
  border-radius: 6px;
  background-color: #082594;
  height: 42px;
  padding: 1px 1px;
}

.btnAt .form-control {
  border: none;
  margin-top: 2px;
  margin-left: 2px;
}

.headerColor {
  color: #000;
}

.btnAt .btn1 {
  position: absolute;
  left: 250px;
  border-radius: 0% !important;
  background-color: #082594;
  border: none;
  padding: 8px 12px 8px 10px;
}

.btnAt .btn2 {
  position: absolute;
  left: 365px;
  border-bottom-left-radius: 2px !important;
  border-top-left-radius: 2px !important;
  border-left: 1px solid #fff !important;
  background-color: #082594;
  border-color: #082594;
  padding: 7px 12px 7px 10px;
  margin-right: 90px;
}

.btnAt1 .btnFU {
  position: absolute;
  left: 350px;
  border-radius: 0% !important;
  background-color: #082594;
  border: none;
  padding: 8px 14px 8px 20px;
}

.btn {
  padding: 15px;
  font-family: "Manrope";
}

.btn.btn-back {
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.16);
  font-size: 18px;
}

.btn.btn-next {
  background-color: var(--theme-blue-color);
  color: #fff;
  position: relative;
  z-index: 0;
  overflow: hidden;
  font-size: 18px;
}

.btn.btn-success,
.btn.btn-danger,
.btn.btn-primary-bg {
  overflow: hidden;
  position: relative;
  z-index: 0;
}

.btn.btn-next:after,
.btn.btn-success::after,
.btn.btn-danger::after,
.btn.btn-primary-bg::after {
  background: #fff;
  content: "";
  height: 155px;
  left: -75px;
  opacity: 0.2;
  position: absolute;
  top: -50px;
  width: 50px;
  -webkit-transition: all 550ms cubic-bezier(0.19, 1, 0.22, 1);
  transition: all 550ms cubic-bezier(0.19, 1, 0.22, 1);
  -webkit-transform: rotate(35deg);
  -ms-transform: rotate(35deg);
  transform: rotate(35deg);
  z-index: -10;
}

.btn.btn-next:hover:after,
.btn.btn-success:hover:after,
.btn.btn-danger:hover:after,
.btn.btn-primary-bg:hover:after {
  left: 120%;
  -webkit-transition: all 550ms cubic-bezier(0.19, 1, 0.22, 1);
  transition: all 550ms cubic-bezier(0.19, 1, 0.22, 1);
}

.FormLabel {
  font-family: "Manrope";
}

.mandatory {
  color: red;
}

.InputCountryCode {
  border-radius: 0.25rem 0 0 0.25rem;
  border-right: 0px;
}

.FormIcon {
  right: 5px;
  top: 5px;
  font-size: 20px;
  color: var(--theme-dark-blue);
  z-index: 4;
}

.company-form-icon {
  top: 8px;
}

.FormOTP input {
  width: 40px;
}

.CustomCheckbox input[type="checkbox"] {
  display: none;
}

.CustomCheckbox input[type="checkbox"]+label {
  display: block;
  position: relative;
  margin-bottom: 10px;
  cursor: pointer;
  font-family: "Manrope";
  width: 100%;
  border: 1px solid #ccc;
  padding: 15px 20px 15px 60px;
  border-radius: 5px;
}

.CustomCheckbox input[type="checkbox"]+label:before {
  content: "";
  display: block;
  width: 20px;
  height: 20px;
  border: 2px solid var(--theme-dark-blue);
  position: absolute;
  left: 20px;
  top: 17px;
  opacity: 0.6;
  -webkit-transition: all 0.12s, border-color 0.08s;
  transition: all 0.12s, border-color 0.08s;
  border-radius: 2px;
}

.CustomCheckbox input[type="checkbox"]:checked+label:before {
  width: 10px;
  top: 15px;
  left: 25px;
  border-radius: 1px;
  opacity: 1;
  border-top-color: transparent;
  border-left-color: transparent;
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
}

.CustomCheckbox input[type="checkbox"]:checked+label {
  border-color: var(--theme-blue-color);
  background-color: #e8edff;
}

.CustomCheckbox .FormIcon {
  right: 20px;
  top: 5px;
}

.FormTable {
  background-color: var(--bg-gray-color);
}

.CustomCard {
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.16);
}

.CustomCard td:first-child {
  width: 160px;
}
 

/******* Form Section CSS End *******/
/******* Swiper Start *******/
.CustomSwiper {
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.16);
}

.CustomIconBg {
  width: 48px;
  height: 48px;
  line-height: 48px;
  background-color: var(--theme-lite-blue);
}

.CustomUnStyled {
  min-height: 210px;
}

.CustomCheckbox-sm input[type="checkbox"]+label {
  padding: 5px 5px 5px 30px;
}

.CustomCheckbox-sm input[type="checkbox"]+label:before {
  top: 7px;
  left: 5px;
}

.CustomCheckbox-sm input[type="checkbox"]:checked+label:before {
  top: 4px;
  left: 12px;
}

.CustomCheckbox-sm input[type="checkbox"]:checked+label {
  background-color: #fff;
}

.CustomStyledMinHt {
  min-height: 270px;
}

/* button.react-responsive-modal-closeButton {
  display: none;
} */

/******* Swiper End *******/

/******* Radio Button Start******/
/* input[type="radio"] {
  display: none;
} */

.CustomRadioButton label:before,
.CustomRadioButton label:after {
  content: "";
  display: block;
  position: absolute;
  border-radius: 50%;
}

.CustomRadioButton label:before {
  width: 20px;
  height: 20px;
  left: 0;
  top: 50%;
  margin-top: -9px;
  border: 2px solid var(--theme-dark-blue);
  opacity: 0.6;
}

.CustomRadioButton label {
  position: relative;
  cursor: pointer;
  margin-right: 15px;
  padding-left: 30px;
}

.NewCustomRadioButton {
  display: flex;
  gap: 8px;
  align-items: center;
  padding: 6px;
  border: 1px solid #E6E6E6;
  border-radius: 4px;
}

.CustomRadioButton label:after {
  width: 0;
  height: 0;
  top: 50%;
  left: 8px;
  margin-top: 0;
  background: var(--theme-dark-blue);
  transition: 0.1s ease-in-out;
}

.CustomRadioButton :checked+label:after {
  height: 12px;
  width: 12px;
  margin-top: -5px;
  left: 4px;
}

.CustomRadioButton :checked+label:before {
  border: 2px solid var(--theme-dark-blue);
}

/****Web loader start*****/
.WebLoader {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  margin: 0 auto;
  top: 0;
  display: flex;
  justify-content: center;
  height: 110%;
  align-items: center;
  z-index: 10;
}

.LoaderImg {
  background: #fff url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center center / 25px;
  width: 52px;
  height: 52px;
  border-radius: 5px;
  box-shadow: 0 0 7px rgba(0, 0, 0, 0.16);
  position: relative;
  z-index: 0;
}

.LoaderImg::before {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 52px;
  height: 52px;
  background: linear-gradient(107deg,
      #ececec 8%,
      rgba(255, 255, 255, 0.16) 18%,
      #ececec 33%);
  border-radius: 5px;
  background-size: 200% 100%;
  -webkit-animation: 1.5s shine linear infinite;
  animation: 1.5s shine linear infinite;
}

@-webkit-keyframes shine {
  to {
    background-position-x: -200%;
  }
}

@keyframes shine {
  to {
    background-position-x: -200%;
  }
}

.WebLoader::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.1);
}

/****Web loader end*****/

/******not_found_section start ******/
.not_found_section img {
  width: 325px;
}

.text_404 {
  font-size: 300px;
  font-family: "Manrope";
  color: var(--theme-blue-color);
  position: absolute;
  top: -65px;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: -1;
  -webkit-animation: move-top 2s linear infinite alternate;
  -moz-animation: move-top 2s linear infinite alternate;
  -o-animation: move-top 2s linear infinite alternate;
  animation: move-top 2s linear infinite alternate;
}

@keyframes move-top {
  0% {
    -webkit-transform: translateY(-30px);
    -moz-transform: translateY(-30px);
    -ms-transform: translateY(-30px);
    transform: translateY(-30px);
  }

  100% {
    -webkit-transform: translateY(0px);
    -moz-transform: translateY(0px);
    -ms-transform: translateY(0px);
    transform: translateY(0px);
  }
}

/******not_found_section end *******/

/********* Mobile responsive *********/
@media screen and (max-width: 767px) {
  .container1{
  padding-inline: 34px;
  }
  .MainPageSection {
    max-height: calc(100vh - 73px);
    overflow-y: auto;
  }

  .MainSection {
    /* min-height: calc(100vh - 53px); */
    margin-bottom: 0px;
  }

  /* .LeadPage {
    max-height: calc(100vh - 165px);
    overflow-y: auto;
  } */
}

/*********dashboard index table design *********/

.modal {
  border-radius: 50px;
  border: 2px solid;
  font-weight: 200;
  color: blue;
}

.nameC {
  color: #000;
  font-weight: 500;
}

.filter button {
  margin: 20px;
  border: 2px solid #082594;
  color: #082594;
  background-color: #f8f8f8;
  border-radius: 10px;
}

.alignCharts {
  display: flex;
  justify-content: space-between;
  background-color: #f8f8f8;
}

#active {
  background-color: #d2fdc5;
  color: #2f9706;
  padding: 2px 5px;
  width: auto;
  border-radius: 5px;
}

#inActive {
  background-color: #f8dbe4;
  color: #fd2807;
  padding: 2px 5px;

  width: auto;
  border-radius: 5px;
}

.alignRight {
  position: absolute;
  right: 20px;
  color: #000;
  font-weight: 200;
}

.align {
  margin-top: 22px;
}

#customized {
  background-color: #fcefbd;
  color: #c0a11f;
  padding: 2px 5px;
  width: auto;
  border-radius: 5px;
}

#maternity {
  background-color: #f6cef3;
  color: #b00ba4;
  width: auto;
  border-radius: 5px;
  padding: 2px 5px;
}

#base {
  background-color: #d2d6f7;
  color: #0b2eb0;
  width: auto;
  border-radius: 5px;
  padding: 2px 5px;
}

#viewed {
  background-color: #dbf8dd;
  color: #32ac3c;
  width: auto;
  border-radius: 5px;
  padding: 2px 5px;
}

.custom-user-type-table table .sticker {
  position: sticky;
  top: 10px;
}

.custom-user-type-table table tbody tr td {
  word-wrap: inherit;
  font-weight: 300;
}

.custom-user-type-table table tbody {
  border-radius: 60px;
}

.custom-user-type-table table thead {
  color: #2a2a2a;
  font-size: 14px;
}

.custom-user-type-table table tbody tr {
  color: #000;
}

.custom-user-type-table table tr {
  border-collapse: collapse;
  box-sizing: border-box;
  background-color: #fff;
  border-top: 20px solid #f8f8f8;
}

.themeGray {
  color: #adaaaa;
}

.policyBg {
  background-color: #f8f8f8 !important;
}

.whiteBg {
  background-color: #ffffff !important;
}

.policyWH {
  height: 422px;
  width: 500px;
  display: flex;
  align-items: flex-end;
  justify-content: center;
}

.policy-card {
  box-shadow: 0px 0px 12px #6c6c6c29;
  border-radius: 14px;
  opacity: 1;
  width: 75%;
  padding: 20px;
  height: 320px;
  display: flex;
}

.policy-card label {
  font-size: 14px;
}

.react-responsive-modal-modal {
  width: 60%;
  border-radius: 9px;
}

.perUser p {
  font-size: 14px;
  margin-bottom: 0;
}

.perUser span {
  font-weight: 600;
  font-size: 15px;
}

.perUser {
  margin-bottom: 15px;
}

.popHead {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 0;
}

.userTypebg {
  background: #f8f8f8 0% 0% no-repeat padding-box;
  color: #444d91;
  padding: 4px;
}

.text-green {
  color: #0f7513;
}

.text-red {
  color: #df1c1c;
}

.text-warn {
  color: #c98808;
}

.btn-policy-search {
  display: flex;
  justify-content: space-between;
  width: 87%;
  box-sizing: border-box;
  position: relative;
  border-radius: 6px;
  background-color: #444d91;
  height: 42px;
  padding: 2px 1px 1px 2px;
}

.completed {
  box-shadow: 0px 0px 12px #6c6c6c29;
  background-color: #ffffff;
  border-top: 5px solid #0f7513;
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
}

.info {
  box-shadow: 0px 0px 12px #6c6c6c29;
  background-color: #ffffff;
  border-top: 5px solid #ffde9e;
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
}

.w-full {
  width: -webkit-fill-available !important
}

.sum-insured-section {
  background: #E6F2FF;
  border-radius: 5px;
  padding: 16px;
  margin: 16px 0px;
}

button:focus {
  outline: none !important;
}`, "",{"version":3,"sources":["webpack://./src/new.css"],"names":[],"mappings":"AAAA,iCAAiC;AACjC;EACE,qBAAqB;EACrB,wBAAwB;EACxB,2BAA2B;EAC3B,oBAAoB;EACpB,0BAA0B;EAC1B,0BAA0B;EAC1B,wBAAwB;AAC1B;;AAEA;EACE,sCAAsC;EACtC,mCAAmC;EACnC,SAAS;EACT,sBAAsB;EACtB,mCAAmC;EACnC,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE;aACW;AACb;;AAEA;;;;;;EAME,sBAAsB;AACxB;;AAEA;;EAEE,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,yCAAyC;EACzC,kDAAkD;EAClD,0CAA0C;EAC1C,2CAA2C;EAC3C,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,uCAAuC;EACvC,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,+CAA+C;EAC/C,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,6BAA6B;EAC7B,kBAAkB;EAClB,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,eAAe;AACjB;;AAEA,+BAA+B;AAC/B,uCAAuC;AACvC;EACE,mBAAmB;EACnB,wCAAwC;;EAExC,kDAAkD;EAClD,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,UAAU;EACV,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,UAAU;EACV,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,4BAA4B;EAC5B,yBAAyB;EACzB,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,yCAAyC;EACzC,sCAAsC;EACtC,sCAAsC;EACtC,yBAAyB;EACzB,qBAAqB;EACrB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,4BAA4B;EAC5B,yBAAyB;EACzB,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,2CAA2C;EAC3C,eAAe;AACjB;;AAEA;EACE,yCAAyC;EACzC,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;;EAGE,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;;;;EAIE,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,4DAA4D;EAC5D,oDAAoD;EACpD,gCAAgC;EAChC,4BAA4B;EAC5B,wBAAwB;EACxB,YAAY;AACd;;AAEA;;;;EAIE,UAAU;EACV,4DAA4D;EAC5D,oDAAoD;AACtD;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,eAAe;EACf,6BAA6B;EAC7B,UAAU;AACZ;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,sBAAsB;EACtB,WAAW;EACX,sBAAsB;EACtB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,WAAW;EACX,YAAY;EACZ,wCAAwC;EACxC,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,YAAY;EACZ,iDAAiD;EACjD,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,UAAU;EACV,6BAA6B;EAC7B,8BAA8B;EAC9B,gCAAgC;EAChC,wBAAwB;AAC1B;;AAEA;EACE,qCAAqC;EACrC,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,QAAQ;AACV;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,YAAY;AACd;;;AAGA,qCAAqC;AACrC,6BAA6B;AAC7B;EACE,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;GAEG;;AAEH,2BAA2B;;AAE3B,iCAAiC;AACjC;;GAEG;;AAEH;;EAEE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,gBAAgB;EAChB,wCAAwC;EACxC,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,QAAQ;EACR,SAAS;EACT,aAAa;EACb,kCAAkC;EAClC,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,wCAAwC;AAC1C;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,cAAc;EACd,MAAM;EACN,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,uFAAyF;EACzF,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uCAAuC;EACvC,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;EACX,YAAY;EACZ;;;kBAGgB;EAChB,kBAAkB;EAClB,0BAA0B;EAC1B,6CAA6C;EAC7C,qCAAqC;AACvC;;AAEA;EACE;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,WAAW;EACX,oCAAoC;AACtC;;AAEA,wBAAwB;;AAExB,qCAAqC;AACrC;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,8BAA8B;EAC9B,kBAAkB;EAClB,UAAU;EACV,OAAO;EACP,SAAS;EACT,QAAQ;EACR,WAAW;EACX,wDAAwD;EACxD,qDAAqD;EACrD,mDAAmD;EACnD,gDAAgD;AAClD;;AAEA;EACE;IACE,oCAAoC;IACpC,iCAAiC;IACjC,gCAAgC;IAChC,4BAA4B;EAC9B;;EAEA;IACE,kCAAkC;IAClC,+BAA+B;IAC/B,8BAA8B;IAC9B,0BAA0B;EAC5B;AACF;;AAEA,oCAAoC;;AAEpC,sCAAsC;AACtC;EACE;EACA,oBAAoB;EACpB;EACA;IACE,8BAA8B;IAC9B,gBAAgB;EAClB;;EAEA;IACE,oCAAoC;IACpC,kBAAkB;EACpB;;EAEA;;;KAGG;AACL;;AAEA,gDAAgD;;AAEhD;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;;EAEhB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,aAAa;EACb,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;EACnB,UAAU;EACV,UAAU;EACV,aAAa;EACb,aAAa;EACb,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,+CAA+C;EAC/C,cAAc;EACd,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,UAAU;EACV,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;EACzB,6BAA6B;EAC7B,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;EACzB,6BAA6B;EAC7B,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;EACE;AACF;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B","sourcesContent":["/******* Common CSS Start *******/\n:root {\n  --text-black: #2a2a2a;\n  --bg-gray-color: #f8f8f8;\n  --theme-blue-color: #35488a;\n  --text-gray: #757575;\n  --theme-dark-blue: #424a66;\n  --theme-red-color: #f11616;\n  --theme-gray-bg: #f2f4f7;\n}\n\nbody {\n  background-color: var(--bg-gray-color);\n  color: var(--text-black) !important;\n  margin: 0;\n  font-family: \"Manrope\";\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  position: relative;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, \"Courier New\",\n    monospace;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  font-family: \"Manrope\";\n}\n\na,\n.btn-link {\n  font-family: \"Manrope\";\n  color: var(--theme-blue-color);\n}\n\n.fs-12 {\n  font-size: 12px;\n}\n\n.fs-14 {\n  font-size: 14px;\n}\n\n.fs-16,\n.btn.fs-16 {\n  font-size: 16px;\n}\n\n.fs-18 {\n  font-size: 18px;\n}\n\n.f400 {\n  font-family: \"Manrope\";\n}\n\n.f500 {\n  font-family: \"Manrope\";\n}\n\n.f600 {\n  font-family: \"Manrope\";\n}\n\n.f700 {\n  font-family: \"Manrope-Bold\";\n}\n\ninput {\n  color: var(--text-black);\n  font-family: \"Manrope\";\n}\n\ninput::placeholder {\n  color: var(--text-gray);\n  font-size: 14px;\n}\n\nheader {\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.16);\n  -webkit-backdrop-filter: saturate(180%) blur(20px);\n  backdrop-filter: saturate(180%) blur(20px);\n  background-color: rgba(255, 255, 255, 0.62);\n  position: sticky;\n  top: 0;\n  z-index: 9;\n}\n\nheader .logo {\n  width: 139px;\n}\n\n.MainSection {\n  max-height: calc(100vh - 72px);\n  margin-bottom: 50px;\n  position: relative;\n  display: inline-block;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  overflow: scroll;\n}\n\n.erro {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  border-radius: 10px;\n  background-color: #fafafa;\n  box-shadow: 0 9px 23px rgb(0 0 0 / 20%);\n  font-size: 22px;\n  color: #d44b4b;\n  width: fit-content;\n  padding: 29px 50px;\n  margin-right: auto;\n  margin-left: auto;\n  margin-top: 15vh;\n  margin-bottom: 5vh;\n  text-transform: capitalize;\n}\n\n.erro img {\n  margin-bottom: 20px;\n}\n\n.MainPage {\n  max-width: 900px;\n  margin-bottom: 70px;\n}\n\n.text-blue {\n  color: var(--theme-blue-color);\n}\n\n.text-policy-blue {\n  color: #444d91;\n  font-size: 16px;\n  font-weight: 700;\n}\n\n.btn-policy-blue {\n  background-color: #444d91 !important;\n  color: #ffffff;\n  border-radius: 5px;\n}\n\n.btn-dash-sec {\n  background: #e7e7e7 0% 0% no-repeat padding-box;\n  border: 1px solid #cccccc;\n  border-radius: 5px;\n}\n\n.w-50px {\n  width: 50px;\n}\n\n.h-50px {\n  height: 50px;\n}\n\np {\n  color: var(--text-black);\n}\n\n.error {\n  padding-left: 18px;\n  font-size: 12px;\n  color: var(--theme-red-color);\n  position: relative;\n  z-index: 0;\n  margin-top: 5px;\n}\n\n.error::before {\n  content: \"\\e80a\";\n  position: absolute;\n  top: -3px;\n  left: 0;\n  font-family: \"fontello\";\n  font-size: 15px;\n}\n\n/******* Common CSS End *******/\n/******* Form Section CSS Start *******/\n.FormSection {\n  border-radius: 15px;\n  box-shadow: 0px 0px 30.8px 0px #0000001A;\n\n  /* box-shadow: 0px 7px 24px rgba(0, 0, 0, 0.07); */\n  min-height: 400px;\n}\n\n.warningBox {\n  border-radius: 15px;\n  background-color: #FFF2E3;\n  padding: 10px;\n  margin-top: 30px;\n}\n\n.warningBox p {\n  padding-top: 10px;\n  text-align: center;\n  color: #FFA439;\n}\n\n.btnAt {\n  display: flex;\n  justify-content: space-between;\n  width: 87%;\n  box-sizing: border-box;\n  position: relative;\n  border-radius: 6px;\n  background-color: #082594;\n  height: 40px;\n}\n\n.btnAt1 #formInp {\n  width: 150%;\n  margin-top: 1px;\n  margin-left: 1px;\n}\n\n.btnAt1 {\n  display: flex;\n  justify-content: space-between;\n  width: 87%;\n  box-sizing: border-box;\n  position: relative;\n  border-radius: 6px;\n  background-color: #082594;\n  height: 42px;\n  padding: 1px 1px;\n}\n\n.btnAt .form-control {\n  border: none;\n  margin-top: 2px;\n  margin-left: 2px;\n}\n\n.headerColor {\n  color: #000;\n}\n\n.btnAt .btn1 {\n  position: absolute;\n  left: 250px;\n  border-radius: 0% !important;\n  background-color: #082594;\n  border: none;\n  padding: 8px 12px 8px 10px;\n}\n\n.btnAt .btn2 {\n  position: absolute;\n  left: 365px;\n  border-bottom-left-radius: 2px !important;\n  border-top-left-radius: 2px !important;\n  border-left: 1px solid #fff !important;\n  background-color: #082594;\n  border-color: #082594;\n  padding: 7px 12px 7px 10px;\n  margin-right: 90px;\n}\n\n.btnAt1 .btnFU {\n  position: absolute;\n  left: 350px;\n  border-radius: 0% !important;\n  background-color: #082594;\n  border: none;\n  padding: 8px 14px 8px 20px;\n}\n\n.btn {\n  padding: 15px;\n  font-family: \"Manrope\";\n}\n\n.btn.btn-back {\n  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.16);\n  font-size: 18px;\n}\n\n.btn.btn-next {\n  background-color: var(--theme-blue-color);\n  color: #fff;\n  position: relative;\n  z-index: 0;\n  overflow: hidden;\n  font-size: 18px;\n}\n\n.btn.btn-success,\n.btn.btn-danger,\n.btn.btn-primary-bg {\n  overflow: hidden;\n  position: relative;\n  z-index: 0;\n}\n\n.btn.btn-next:after,\n.btn.btn-success::after,\n.btn.btn-danger::after,\n.btn.btn-primary-bg::after {\n  background: #fff;\n  content: \"\";\n  height: 155px;\n  left: -75px;\n  opacity: 0.2;\n  position: absolute;\n  top: -50px;\n  width: 50px;\n  -webkit-transition: all 550ms cubic-bezier(0.19, 1, 0.22, 1);\n  transition: all 550ms cubic-bezier(0.19, 1, 0.22, 1);\n  -webkit-transform: rotate(35deg);\n  -ms-transform: rotate(35deg);\n  transform: rotate(35deg);\n  z-index: -10;\n}\n\n.btn.btn-next:hover:after,\n.btn.btn-success:hover:after,\n.btn.btn-danger:hover:after,\n.btn.btn-primary-bg:hover:after {\n  left: 120%;\n  -webkit-transition: all 550ms cubic-bezier(0.19, 1, 0.22, 1);\n  transition: all 550ms cubic-bezier(0.19, 1, 0.22, 1);\n}\n\n.FormLabel {\n  font-family: \"Manrope\";\n}\n\n.mandatory {\n  color: red;\n}\n\n.InputCountryCode {\n  border-radius: 0.25rem 0 0 0.25rem;\n  border-right: 0px;\n}\n\n.FormIcon {\n  right: 5px;\n  top: 5px;\n  font-size: 20px;\n  color: var(--theme-dark-blue);\n  z-index: 4;\n}\n\n.company-form-icon {\n  top: 8px;\n}\n\n.FormOTP input {\n  width: 40px;\n}\n\n.CustomCheckbox input[type=\"checkbox\"] {\n  display: none;\n}\n\n.CustomCheckbox input[type=\"checkbox\"]+label {\n  display: block;\n  position: relative;\n  margin-bottom: 10px;\n  cursor: pointer;\n  font-family: \"Manrope\";\n  width: 100%;\n  border: 1px solid #ccc;\n  padding: 15px 20px 15px 60px;\n  border-radius: 5px;\n}\n\n.CustomCheckbox input[type=\"checkbox\"]+label:before {\n  content: \"\";\n  display: block;\n  width: 20px;\n  height: 20px;\n  border: 2px solid var(--theme-dark-blue);\n  position: absolute;\n  left: 20px;\n  top: 17px;\n  opacity: 0.6;\n  -webkit-transition: all 0.12s, border-color 0.08s;\n  transition: all 0.12s, border-color 0.08s;\n  border-radius: 2px;\n}\n\n.CustomCheckbox input[type=\"checkbox\"]:checked+label:before {\n  width: 10px;\n  top: 15px;\n  left: 25px;\n  border-radius: 1px;\n  opacity: 1;\n  border-top-color: transparent;\n  border-left-color: transparent;\n  -webkit-transform: rotate(45deg);\n  transform: rotate(45deg);\n}\n\n.CustomCheckbox input[type=\"checkbox\"]:checked+label {\n  border-color: var(--theme-blue-color);\n  background-color: #e8edff;\n}\n\n.CustomCheckbox .FormIcon {\n  right: 20px;\n  top: 5px;\n}\n\n.FormTable {\n  background-color: var(--bg-gray-color);\n}\n\n.CustomCard {\n  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.16);\n}\n\n.CustomCard td:first-child {\n  width: 160px;\n}\n \n\n/******* Form Section CSS End *******/\n/******* Swiper Start *******/\n.CustomSwiper {\n  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.16);\n}\n\n.CustomIconBg {\n  width: 48px;\n  height: 48px;\n  line-height: 48px;\n  background-color: var(--theme-lite-blue);\n}\n\n.CustomUnStyled {\n  min-height: 210px;\n}\n\n.CustomCheckbox-sm input[type=\"checkbox\"]+label {\n  padding: 5px 5px 5px 30px;\n}\n\n.CustomCheckbox-sm input[type=\"checkbox\"]+label:before {\n  top: 7px;\n  left: 5px;\n}\n\n.CustomCheckbox-sm input[type=\"checkbox\"]:checked+label:before {\n  top: 4px;\n  left: 12px;\n}\n\n.CustomCheckbox-sm input[type=\"checkbox\"]:checked+label {\n  background-color: #fff;\n}\n\n.CustomStyledMinHt {\n  min-height: 270px;\n}\n\n/* button.react-responsive-modal-closeButton {\n  display: none;\n} */\n\n/******* Swiper End *******/\n\n/******* Radio Button Start******/\n/* input[type=\"radio\"] {\n  display: none;\n} */\n\n.CustomRadioButton label:before,\n.CustomRadioButton label:after {\n  content: \"\";\n  display: block;\n  position: absolute;\n  border-radius: 50%;\n}\n\n.CustomRadioButton label:before {\n  width: 20px;\n  height: 20px;\n  left: 0;\n  top: 50%;\n  margin-top: -9px;\n  border: 2px solid var(--theme-dark-blue);\n  opacity: 0.6;\n}\n\n.CustomRadioButton label {\n  position: relative;\n  cursor: pointer;\n  margin-right: 15px;\n  padding-left: 30px;\n}\n\n.NewCustomRadioButton {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  padding: 6px;\n  border: 1px solid #E6E6E6;\n  border-radius: 4px;\n}\n\n.CustomRadioButton label:after {\n  width: 0;\n  height: 0;\n  top: 50%;\n  left: 8px;\n  margin-top: 0;\n  background: var(--theme-dark-blue);\n  transition: 0.1s ease-in-out;\n}\n\n.CustomRadioButton :checked+label:after {\n  height: 12px;\n  width: 12px;\n  margin-top: -5px;\n  left: 4px;\n}\n\n.CustomRadioButton :checked+label:before {\n  border: 2px solid var(--theme-dark-blue);\n}\n\n/****Web loader start*****/\n.WebLoader {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  margin: 0 auto;\n  top: 0;\n  display: flex;\n  justify-content: center;\n  height: 110%;\n  align-items: center;\n  z-index: 10;\n}\n\n.LoaderImg {\n  background: #fff url(../public/assets/img/star-invert.svg) no-repeat center center / 25px;\n  width: 52px;\n  height: 52px;\n  border-radius: 5px;\n  box-shadow: 0 0 7px rgba(0, 0, 0, 0.16);\n  position: relative;\n  z-index: 0;\n}\n\n.LoaderImg::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  width: 52px;\n  height: 52px;\n  background: linear-gradient(107deg,\n      #ececec 8%,\n      rgba(255, 255, 255, 0.16) 18%,\n      #ececec 33%);\n  border-radius: 5px;\n  background-size: 200% 100%;\n  -webkit-animation: 1.5s shine linear infinite;\n  animation: 1.5s shine linear infinite;\n}\n\n@-webkit-keyframes shine {\n  to {\n    background-position-x: -200%;\n  }\n}\n\n@keyframes shine {\n  to {\n    background-position-x: -200%;\n  }\n}\n\n.WebLoader::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  width: 100%;\n  background-color: rgba(0, 0, 0, 0.1);\n}\n\n/****Web loader end*****/\n\n/******not_found_section start ******/\n.not_found_section img {\n  width: 325px;\n}\n\n.text_404 {\n  font-size: 300px;\n  font-family: \"Manrope\";\n  color: var(--theme-blue-color);\n  position: absolute;\n  top: -65px;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  z-index: -1;\n  -webkit-animation: move-top 2s linear infinite alternate;\n  -moz-animation: move-top 2s linear infinite alternate;\n  -o-animation: move-top 2s linear infinite alternate;\n  animation: move-top 2s linear infinite alternate;\n}\n\n@keyframes move-top {\n  0% {\n    -webkit-transform: translateY(-30px);\n    -moz-transform: translateY(-30px);\n    -ms-transform: translateY(-30px);\n    transform: translateY(-30px);\n  }\n\n  100% {\n    -webkit-transform: translateY(0px);\n    -moz-transform: translateY(0px);\n    -ms-transform: translateY(0px);\n    transform: translateY(0px);\n  }\n}\n\n/******not_found_section end *******/\n\n/********* Mobile responsive *********/\n@media screen and (max-width: 767px) {\n  .container1{\n  padding-inline: 34px;\n  }\n  .MainPageSection {\n    max-height: calc(100vh - 73px);\n    overflow-y: auto;\n  }\n\n  .MainSection {\n    /* min-height: calc(100vh - 53px); */\n    margin-bottom: 0px;\n  }\n\n  /* .LeadPage {\n    max-height: calc(100vh - 165px);\n    overflow-y: auto;\n  } */\n}\n\n/*********dashboard index table design *********/\n\n.modal {\n  border-radius: 50px;\n  border: 2px solid;\n  font-weight: 200;\n  color: blue;\n}\n\n.nameC {\n  color: #000;\n  font-weight: 500;\n}\n\n.filter button {\n  margin: 20px;\n  border: 2px solid #082594;\n  color: #082594;\n  background-color: #f8f8f8;\n  border-radius: 10px;\n}\n\n.alignCharts {\n  display: flex;\n  justify-content: space-between;\n  background-color: #f8f8f8;\n}\n\n#active {\n  background-color: #d2fdc5;\n  color: #2f9706;\n  padding: 2px 5px;\n  width: auto;\n  border-radius: 5px;\n}\n\n#inActive {\n  background-color: #f8dbe4;\n  color: #fd2807;\n  padding: 2px 5px;\n\n  width: auto;\n  border-radius: 5px;\n}\n\n.alignRight {\n  position: absolute;\n  right: 20px;\n  color: #000;\n  font-weight: 200;\n}\n\n.align {\n  margin-top: 22px;\n}\n\n#customized {\n  background-color: #fcefbd;\n  color: #c0a11f;\n  padding: 2px 5px;\n  width: auto;\n  border-radius: 5px;\n}\n\n#maternity {\n  background-color: #f6cef3;\n  color: #b00ba4;\n  width: auto;\n  border-radius: 5px;\n  padding: 2px 5px;\n}\n\n#base {\n  background-color: #d2d6f7;\n  color: #0b2eb0;\n  width: auto;\n  border-radius: 5px;\n  padding: 2px 5px;\n}\n\n#viewed {\n  background-color: #dbf8dd;\n  color: #32ac3c;\n  width: auto;\n  border-radius: 5px;\n  padding: 2px 5px;\n}\n\n.custom-user-type-table table .sticker {\n  position: sticky;\n  top: 10px;\n}\n\n.custom-user-type-table table tbody tr td {\n  word-wrap: inherit;\n  font-weight: 300;\n}\n\n.custom-user-type-table table tbody {\n  border-radius: 60px;\n}\n\n.custom-user-type-table table thead {\n  color: #2a2a2a;\n  font-size: 14px;\n}\n\n.custom-user-type-table table tbody tr {\n  color: #000;\n}\n\n.custom-user-type-table table tr {\n  border-collapse: collapse;\n  box-sizing: border-box;\n  background-color: #fff;\n  border-top: 20px solid #f8f8f8;\n}\n\n.themeGray {\n  color: #adaaaa;\n}\n\n.policyBg {\n  background-color: #f8f8f8 !important;\n}\n\n.whiteBg {\n  background-color: #ffffff !important;\n}\n\n.policyWH {\n  height: 422px;\n  width: 500px;\n  display: flex;\n  align-items: flex-end;\n  justify-content: center;\n}\n\n.policy-card {\n  box-shadow: 0px 0px 12px #6c6c6c29;\n  border-radius: 14px;\n  opacity: 1;\n  width: 75%;\n  padding: 20px;\n  height: 320px;\n  display: flex;\n}\n\n.policy-card label {\n  font-size: 14px;\n}\n\n.react-responsive-modal-modal {\n  width: 60%;\n  border-radius: 9px;\n}\n\n.perUser p {\n  font-size: 14px;\n  margin-bottom: 0;\n}\n\n.perUser span {\n  font-weight: 600;\n  font-size: 15px;\n}\n\n.perUser {\n  margin-bottom: 15px;\n}\n\n.popHead {\n  font-size: 18px;\n  font-weight: 600;\n  margin-bottom: 0;\n}\n\n.userTypebg {\n  background: #f8f8f8 0% 0% no-repeat padding-box;\n  color: #444d91;\n  padding: 4px;\n}\n\n.text-green {\n  color: #0f7513;\n}\n\n.text-red {\n  color: #df1c1c;\n}\n\n.text-warn {\n  color: #c98808;\n}\n\n.btn-policy-search {\n  display: flex;\n  justify-content: space-between;\n  width: 87%;\n  box-sizing: border-box;\n  position: relative;\n  border-radius: 6px;\n  background-color: #444d91;\n  height: 42px;\n  padding: 2px 1px 1px 2px;\n}\n\n.completed {\n  box-shadow: 0px 0px 12px #6c6c6c29;\n  background-color: #ffffff;\n  border-top: 5px solid #0f7513;\n  border-bottom-left-radius: 12px;\n  border-bottom-right-radius: 12px;\n}\n\n.info {\n  box-shadow: 0px 0px 12px #6c6c6c29;\n  background-color: #ffffff;\n  border-top: 5px solid #ffde9e;\n  border-bottom-left-radius: 12px;\n  border-bottom-right-radius: 12px;\n}\n\n.w-full {\n  width: -webkit-fill-available !important\n}\n\n.sum-insured-section {\n  background: #E6F2FF;\n  border-radius: 5px;\n  padding: 16px;\n  margin: 16px 0px;\n}\n\nbutton:focus {\n  outline: none !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
